import { render, staticRenderFns } from "./DesplegarComentarios.vue?vue&type=template&id=7be2cd17"
import script from "./DesplegarComentarios.vue?vue&type=script&lang=js"
export * from "./DesplegarComentarios.vue?vue&type=script&lang=js"
import style0 from "./DesplegarComentarios.vue?vue&type=style&index=0&id=7be2cd17&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports